var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"footer-social"},_vm._l((_vm.parsedLinks),function(item,i){return (item !== undefined)?_c('a',{key:i,staticClass:"footer-social__icon",class:`footer-social__icon_${item.name}`,attrs:{"href":item.href}},[_c('font-awesome-icon',{attrs:{"name":`pinq_${item.name}`}})],1):_vm._e()}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }